<template>
  <div class="user" style="padding-bottom: 0;margin-top: 0;">
    <div class="info" v-if="user" style="margin-top: 1em;">

      <div class="d-flex">
        <div class="photo">
          <img :src="require('@/assets/img/proAvatar.png')" alt="avatar" v-if="!currentUser || !currentUser.profileImage" :key="currentUser.profileImage" />
          <profile-image :file-id="currentUser.profileImage" v-if="currentUser && currentUser.profileImage">
          </profile-image>
        </div>

        <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleSidebar" href="#" style="padding-inline-start: 0px;">
          <span>{{ user.firstName }} {{ user.lastName }}</span>
        </a>
      </div>

      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav">
            <slot>
              <!-- <li>
                <a href="#vue">
                  <span class="sidebar-mini-icon">MP</span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li>
              <li>
                <a href="#vue">
                  <span class="sidebar-mini-icon">EP</span>
                  <span class="sidebar-normal">Edit Profile</span>
                </a>
              </li>-->

              <li>
                <a>
                  <i class="fa fa-globe-asia" style="font-size: 1.3em;line-height:2em;"></i>
                  <drop-down tag="div" :title="$t('message.Language') + ' (' + getLocaleName() + ')'" titleClass="menu-text">
                    <a class="dropdown-item" @click="selectLanguage('en-US')" v-if="isSupportedLanguage('en-US')">English</a>
                    <a class="dropdown-item" @click="selectLanguage('hi')" v-if="isSupportedLanguage('hi')">हिन्दी</a>
                    <a class="dropdown-item" @click="selectLanguage('el-GR')" v-if="isSupportedLanguage('el-GR')">Ελληνικά</a>
                    <a class="dropdown-item" @click="selectLanguage('es-ES')" v-if="isSupportedLanguage('es-ES')">Español</a>
                    <a class="dropdown-item" @click="selectLanguage('ru')" v-if="isSupportedLanguage('ru')">русский</a>
                    <a class="dropdown-item" @click="selectLanguage('kn')" v-if="isSupportedLanguage('kn')">ಕನ್ನಡ</a>
                    <a class="dropdown-item" @click="selectLanguage('ar')" v-if="isSupportedLanguage('ar')">عربي</a>
                    <a class="dropdown-item" @click="selectLanguage('fr')" v-if="isSupportedLanguage('fr')">française</a>
                  </drop-down>
                </a>
              </li>
              <li v-if="user.roles.includes('nurse') || user.roles.includes('doctor')">
                <a @click="goToDashboard()">
                  <i class="now-ui-icons design_app" style="font-size: 1.3em;"></i>
                  <div>
                    <span class="sidebar-normal menu-text"> {{
                      $t("message.Dashboard")
                    }} </span>
                  </div>
                </a>
              </li>
              <li>
                <a @click="changePassword">
                  <i class="now-ui-icons objects_key-25" style="font-size: 1.3em;font-weight:bold;"></i>
                  <span class="sidebar-normal menu-text">{{
                    $t("message.Change Password")
                  }}</span>
                </a>
              </li>
              <li v-if="user.roles.includes('doctor')">
                <a @click="goToMyAvailability()">
                  <i class="fas fa-calendar-check" style="font-size: 1.3em;"></i>
                  <span class="sidebar-normal menu-text">{{
                    $t("message.My Availability")
                  }}</span>
                </a>
              </li>
              <li v-if="user.roles.includes('nurse') && settings.paymentSettings.creditPoints && settings.paymentSettings.creditPoints.enabled">
                <a @click="goToCredits()">
                  <i class="fas fa-coins" style="font-size: 1.3em;"></i>
                  <div>
                    <span class="sidebar-normal menu-text">{{
                      $t("message.Credits")
                    }} ({{ userDetails.credits }})
                      <badge v-if="userDetails.credits < 500" type="danger" style="position: relative; border-radius: 50%; height: 15px; width: 15px; margin: auto;padding: 0; top: 0.3em;">
                        <i class="fas fa-exclamation" style="line-height: inherit; font-size: inherit; margin: 0; position: absolute; height: 1em; width: 1em; top: 1px; left: 2px; color: white;"></i>
                      </badge>
                    </span>
                  </div>
                </a>
              </li>
              <li v-if="user.roles.includes('nurse') && settings.paymentSettings.creditPoints && settings.paymentSettings.creditPoints.enabled">
                <a @click="goToEarnings()">
                  <i class="fas fa-rupee-sign" style="font-size: 1.3em;"></i>
                  <div>
                    <span class="sidebar-normal menu-text"> {{ $t("message.Earnings") }} </span>
                  </div>
                </a>
              </li>
              <li v-if="user.roles.includes('ambulance-driver')">
                <a @click="goToVehicleStats()">
                  <i class="fas fa-ambulance" style="font-size: 1.3em;"></i>
                  <span class="sidebar-normal menu-tex">{{
                    $t("message.Vehicle Statistics")
                  }}
                  </span>
                </a>
              </li>
              <li v-if="user.roles.includes('patient') && IS_MEDICATION_REMINDER_ENABLED()">
                <a @click="goToReminders()">
                  <i class="fas fa-bell" style="font-size: 1.3em;"></i>
                  <span class="sidebar-normal menu-text">
                    {{ $t('message.Reminders') }}
                  </span>
                </a>
              </li>
              <li>
                <a @click="logout()">
                  <i class="fas fa-sign-out-alt" style="font-size: 1.3em;"></i>
                  <span class="sidebar-normal menu-text">{{
                    $t("message.Logout")
                  }}</span>
                </a>
              </li>
              <li>
                <a @click="goToHelp()" style="
                    border-top: 1px solid rgba(255, 255, 255, 0.5);
                    border-radius: 0px;
                    padding-top: 25px;
                  ">
                  <i class="fas fa-life-ring" style="font-size: 1.3em;"></i>
                  <span class="sidebar-normal menu-text">{{ $t("message.Help & Support") }}</span>
                </a>
              </li>
              <li>
                <a @click="goToTermsOfUse()">
                  <i class="fas fa-file-alt" style="font-size: 1.3em;"></i>
                  <span class="sidebar-normal  menu-text">{{ $t("message.Terms of Use") }}</span>
                </a>
              </li>
              <li>
                <a @click="goToPrivacyPolicy()">
                  <i class="fas fa-user-shield" style="font-size: 1.3em;"></i>
                  <span class="sidebar-normal menu-text">{{ $t("message.Privacy Policy") }}</span>
                </a>
              </li>
            </slot>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { Switch } from "src/components";
import ProfileImage from "../../../carenation/components/ProfileImage.vue";
export default {
  components: {
    CollapseTransition,
    ProfileImage,
    [Switch.name]: Switch,
  },
  props: {
    title: {
      type: String,
      default: "James Amos",
    },
  },
  data() {
    return {
      isClosed: true,
      Authentication: {},
      IS_ACTIVE: true,
    };
  },

  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    goToDashboard() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      if (this.user.roles.includes("nurse")) {
        this.$router.push("dashboard");
      } else if (this.user.roles.includes("doctor")) {
        this.$router.push("doctordashboard");
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("profile");
    },
    changePassword() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("changepassword");
    },
    goToMyAvailability() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("myavailability");
    },
    goToCredits() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("credits");
    },
    goToEarnings() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("earnings");
    },
    goToTermsOfUse() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("/termsofuse");
    },
    goToPrivacyPolicy() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("/privacypolicy");
    },
    goToHelp() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("/helpvideos");
    },
    goToVehicleStats() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("/vehiclestats");
    },
    goToReminders() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("/reminders");
    },
    goToBatteryOptimization() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      this.$router.push("/batteryoptimization");
    },
    async logout() {
      swal
        .fire({
          title: this.$t("message.Logout"),
          confirmButtonText: this.$t("message.Logout"),
          text: this.$t("message.You will return to login screen"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Cancel"),
        })
        .then(async (result) => {
          if (result && result.value) {
            try {
              let deviceToken = localStorage.firebaseToken;
              await this.$store.dispatch("signout", {
                userId: this.user._id,
                deviceToken: deviceToken,
              });
              // re-setting caregroup detials to fetch caregroup details when user signin
              this.$store.commit("setState", {
                stateName: "caregroup",
                stateValue: null,
              });
              this.$store.commit("setState", {
                stateName: "blogFeed",
                stateValue: null,
              });
              //Unscribing from vitals topic
              if (this.user.roles.indexOf("careCoordinator") > -1) {
                let userDetails = this.$store.state.userDetails;
                for (let i in userDetails.caregroups) {
                  let vitalTopic =
                    this.instance +
                    "-" +
                    this.user.tenant.name +
                    "-" +
                    userDetails.caregroups[i].name +
                    "-vitals";
                  // cordova.plugins.firebase.messaging.unsubscribe(vitalTopic);
                  console.log("Unsubscribed from topic - " + vitalTopic);
                }
              }
              localStorage.user = null;
              this.$router.push({ name: "Login" });
            } catch {
              swal.fire({
                title: "Error",
                text: this.$t("message.Unable to logout"),
                type: "error",
                timer: 5000,
              });
            }
          }
        });
    },
    selectLanguage(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$store.commit("setState", {
        stateName: "tabsRenderCount",
        stateValue: this.$store.state.tabsRenderCount + 1,
      });
    },
    isSupportedLanguage(code) {
      if (
        this.settings &&
        this.settings.supportedLanguages &&
        this.settings.supportedLanguages.length > 0
      ) {
        let language = this.settings.supportedLanguages.find((lang) => {
          return lang.code == code;
        });

        if (language) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    IS_MEDICATION_REMINDER_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.myHealthTab &&
        this.settings.patientAppSetting.myHealthTab.enabled
      );
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
    settings() {
      return this.$store.state.settings;
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
<style scoped>
.app-version {
  margin: 10px 15px 0;
  border-radius: 30px;
  color: #ffffff;
  display: block;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  font-size: 0.7142em;
  padding: 10px 2em;
  line-height: 1.625rem;
  font-family: monospace;
}

/deep/ .dropdown a:not([href]):not([tabindex]) {
  color: inherit !important;
}

/deep/a.dropdown-toggle.nav-link {
  padding-left: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

/deep/span.no-icon {
  color: #ffffff;
}

/deep/.menu-text {
  text-transform: none;
  font-size: 1.3em;
}
</style>
